import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class GroupMembersApi {
  constructor(private axios: AxiosService) {}

  deleteGroupMember = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteGroupMember(id),
    )
    return response
  }
}
